import { useTranslation } from 'react-i18next';
import { useBodyClass } from '@/hooks/useBodyClass';
import Layout from '@/components/Layout/Layout';
import image404 from '@/assets/media/img/imatge-404.png';
import image404_2x from '@/assets/media/img/imatge-404@2x.png';
import { Link, useParams } from 'react-router';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '@/i18n';

function NotFound() {
    const { t } = useTranslation();
    const { lang } = useParams();
    const isValidLang = SUPPORTED_LANGUAGES.includes(lang);
    const finalLang = isValidLang ? lang : DEFAULT_LANGUAGE
    useBodyClass('not-found');

    return (
        <Layout>
            <div className="wrapper">
                <div className="flow--xl is-flex is-flex-direction-column is-align-items-center has-text-white has-text-centered">
                    <img src={image404} srcSet={image404_2x} width="224" height="224" alt=""/>
                    <h1 className="is-family-secondary fluid-24-42 is-uppercase">{t('Error 404')}</h1>
                    <p className="is-size-2 has-text-light">{t('La pagina que buscas no existe')}</p>
                    <div className="columns w-100">
                        <div className="column is-one-third m-auto">
                            <p>{t('Puedes')} <Link to={"/" + finalLang} className="has-text-white"><strong>{t('volver a la pagina principal')}</strong></Link>{t('revisar menu o intentar busqueda')}</p>
                        </div>
                    </div>

                </div>
            </div>
        </Layout>
    );
}

export default NotFound;
